export const ChevronRightIcon = () => (
  <svg className="mc-icon-svg" xmlns="http://www.w3.org/2000/svg" width="10px" height="31px" viewBox="0 0 10 31">
    <path fill="#fff" d="M10,15.5L0.633,0.492L0,1.507L8.734,15.5L0,29.494l0.633,1.014l8.735-13.994v0L10,15.5z" />
  </svg>
);
